import React, { useState } from "react";
import Modal from "react-modal";

Modal.setAppElement("#root");

const Footer = () => {
  const [modalContent, setModalContent] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const openModal = async (type) => {
    // Construct the Flask API URL
    const apiUrl = `${process.env.REACT_APP_LANDING_URL}/legal/${type}`; 
    try {
      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const text = await response.text();
      setModalContent(text);
      setIsOpen(true);
    } catch (err) {
      console.error("Error loading legal content:", err);
      setModalContent("<p>Failed to load content. Please try again later.</p>");
      setIsOpen(true);
    }
  };

  return (
    <>
      <footer
        style={{
          textAlign: "center",
          padding: "1rem",
          borderTop: "1px solid #ccc",
          marginTop: "2rem",
        }}
      >
        <p
          style={{
            marginBottom: "1rem",
            color: "#555",
            fontSize: "0.9rem",
          }}
        >
          ⚠️ CritiCoach uses AI-generated arguments with intentional reasoning flaws for educational purposes. Content may contain inaccuracies and should not be relied upon as factual.
        </p>

        {[
          { type: "terms", label: "Terms of Service" },
          { type: "privacy", label: "Privacy Policy" },
          { type: "disclaimer", label: "Disclaimer" },
        ].map((item) => {
            return (
              <span
                key={item.type}
                onClick={() => openModal(item.type)}
                style={{
                  margin: "0 1rem",
                  cursor: "pointer",
                  color: "#405159",
                  textDecoration: "none",
                  fontSize: "1rem",
                  transition: "color 0.2s, text-decoration 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.target.style.textDecoration = "underline";
                  e.target.style.color = "#405159";
                }}
                onMouseLeave={(e) => {
                  e.target.style.textDecoration = "none";
                  e.target.style.color = "#405159";
                }}
              >
                {item.label}
              </span>
            );
          }
        )}
        {/* © Notice */}
        <p
          style={{
            marginTop: "1.5rem",
            color: "#888",
            fontSize: ".98rem",
          }}
        >
          © 2025 Infivista, Inc. All rights reserved.
        </p>
      </footer>

      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1000,
          },
          content: {
            maxWidth: "700px",
            margin: "auto",
            padding: "2rem",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
            borderRadius: "8px",
            border: "1px solid #ccc",
            backgroundColor: "#f9fbfc",
          },
        }}
      >
        <button
          onClick={() => setIsOpen(false)}
          style={{
            float: "right",
            fontSize: "1.5rem",
            fontWeight: "bold",
            border: "none",
            background: "transparent",
            cursor: "pointer",
            lineHeight: "1",
          }}
          aria-label="Close"
        >
          &times;
        </button>
        <div
          dangerouslySetInnerHTML={{ __html: modalContent }}
          style={{ marginTop: "1rem" }}
        />
      </Modal>
    </>
  );
};

export default Footer;
